module.exports = __webpack_public_path__ + "img/title_background.44f20679.png";